
import { useState } from "react";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useNotifications } from "@/hooks/use-notifications";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { NotificationHistory } from "@/components/notifications/NotificationHistory";

export const NotificationIcon = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const { unreadCount } = useNotifications();
  
  const handleNavigateToNotifications = () => {
    setOpen(false);
    navigate("/notifications");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative text-gray-700 hover:text-blue-600"
          aria-label="Notifications"
        >
          <Bell className="h-5 w-5" />
          {unreadCount && unreadCount > 0 ? (
            <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500" />
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <div className="flex items-center justify-between border-b p-3">
          <h4 className="font-medium">Notifications</h4>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleNavigateToNotifications}
          >
            Voir tout
          </Button>
        </div>
        <div className="max-h-[300px] overflow-auto">
          <NotificationHistory 
            limit={5} 
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};
